if (!customElements.get('zc-sticky-atc')) {
  customElements.define(
    'zc-sticky-atc',
    class ZcStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.mainSubmit = document.getElementById(this.dataset.submitTarget);
        if (!this.mainSubmit) return;

        this.button = this.querySelector('[data-zc-sticky-submit]');
        this.priceEl = this.querySelector('[data-zc-sticky-price]');

        this.button.addEventListener('click', () => {
          const submit = document.getElementById(this.dataset.submitTarget);
          if (submit && !submit.disabled) submit.click();
        });

        // bara apare doar după ce butonul principal a ieșit din viewport (în sus)
        this.visibilityObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.toggleAttribute('hidden', !passed);
          });
        });
        this.visibilityObserver.observe(this.mainSubmit);

        // sincronizează prețul și starea butonului când Dawn re-randează la schimbarea variantei
        const mainPrice = document.getElementById(`price-${this.sectionId}`);
        this.syncObserver = new MutationObserver(() => this.sync());
        if (mainPrice) {
          this.syncObserver.observe(mainPrice, { childList: true, subtree: true, characterData: true });
        }
        this.syncObserver.observe(this.mainSubmit, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });
        this.sync();
      }

      sync() {
        const mainPrice = document.querySelector(`#price-${this.sectionId} .price`);
        if (mainPrice && this.priceEl) this.priceEl.innerHTML = mainPrice.outerHTML;

        const submit = document.getElementById(this.dataset.submitTarget);
        if (!submit || !this.button) return;
        const disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
        this.button.disabled = disabled;
        const label = submit.querySelector('span');
        if (label && label.textContent.trim().length) {
          this.button.textContent = label.textContent.trim();
        }
      }

      disconnectedCallback() {
        if (this.visibilityObserver) this.visibilityObserver.disconnect();
        if (this.syncObserver) this.syncObserver.disconnect();
      }
    }
  );
}
